import {APPLICATION_ROUTES_CONSTANTS} from './application-routes.constants';
import {ENTITIES_CONSTANTS} from './entities.constants';

export interface MenuItem {
  name: string;
  highlighted?: boolean;
  route: string;
  faIcon?: string;
}

export enum MenuGroup {
  Activities = 'Activities',
  Tools = 'Tools',
  Setup = 'Set up'
}

export interface MenuGroupItem {
  name: MenuGroup;
  items: MenuItem[];
}

export const MENU_ITEMS_CONSTANTS: MenuGroupItem[] = [
  {
    name: MenuGroup.Activities,
    items: [
      // Dashboard is hidden/disabled for now - default landing route is the library instead
      // {
      //   name: ENTITIES_CONSTANTS.PLURAL.DASHBOARD,
      //   route: APPLICATION_ROUTES_CONSTANTS.ROUTES.DASHBOARD,
      //   faIcon: 'fa-solid fa-grip'
      // },
      {
        name: ENTITIES_CONSTANTS.PLURAL.REVIEW_SESSION,
        highlighted: true,
        route: APPLICATION_ROUTES_CONSTANTS.ROUTES.REVIEW_SESSION.REVIEW_SESSION,
        faIcon: 'fa-solid fa-bolt'
      },
      {
        name: ENTITIES_CONSTANTS.PLURAL.SOURCES,
        route: APPLICATION_ROUTES_CONSTANTS.ROUTES.SOURCES,
        faIcon: 'fa-solid fa-book'
      },
      // Highlights are accessed via the library sources, not directly from the menu
      // {
      //   name: ENTITIES_CONSTANTS.PLURAL.HIGHLIGHTS,
      //   route: APPLICATION_ROUTES_CONSTANTS.ROUTES.HIGHLIGHTS,
      //   faIcon: 'fa-solid fa-quote-left'
      // },
      // {
      //   name: ENTITIES_CONSTANTS.PLURAL.REMINDER_LOGS,
      //   route: APPLICATION_ROUTES_CONSTANTS.ROUTES.REMINDER_LOGS,
      //   faIcon: 'fa-solid fa-folder-closed'
      // },
    ],
  },
  {
    name: MenuGroup.Tools,
    items: [
      {
        name: ENTITIES_CONSTANTS.PLURAL.IMPORT,
        route: APPLICATION_ROUTES_CONSTANTS.ROUTES.IMPORT.IMPORT,
        faIcon: 'fa-solid fa-file-arrow-up'
      },
      // {
      //   name: ENTITIES_CONSTANTS.PLURAL.EXPORT,
      //   route: APPLICATION_ROUTES_CONSTANTS.ROUTES.EXPORT,
      //   faIcon: 'fa-solid fa-file-arrow-down'
      // },
    ],
  },
  {
    name: MenuGroup.Setup,
    items: [
      {
        name: ENTITIES_CONSTANTS.PLURAL.SETTINGS,
        route: APPLICATION_ROUTES_CONSTANTS.ROUTES.USER_SETTINGS,
        faIcon: 'fa-solid fa-sliders'
      },
    ],
  },
];
